import { get } from '../../../container';
import ME from '../../../api/query/Me';
import UPDATE_COMMENT from '../../../api/query/UpdateComment';
import UPDATE_AVATAR from '../../../api/query/UpdateAvatar';

export const GET_PROFILE_LOADING = 'GET_PROFILE_LOADING';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';
export const UPDATE_AVATAR_LOADING = 'UPDATE_AVATAR_LOADING';
export const UPDATE_AVATAR_SUCCESS = 'UPDATE_AVATAR_SUCCESS';
export const UPDATE_AVATAR_FAILURE = 'UPDATE_AVATAR_FAILURE';
export const UPDATE_COMMENT_LOADING = 'UPDATE_COMMENT_LOADING';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAILURE = 'UPDATE_COMMENT_FAILURE';

export function getProfile() {
  return (dispatch) => {
    dispatch({ type: GET_PROFILE_LOADING });

    get('graphql').query(ME, undefined, ({ data }) => {
      const profile = data.Me;

      dispatch({ type: GET_PROFILE_SUCCESS, payload: { profile } });
    }, (status) => dispatch({ type: GET_PROFILE_FAILURE, payload: { status } }));
  };
}

/**
 * @param {String} comment
 */
export function updateComment(comment) {
  return (dispatch) => {
    dispatch({ type: UPDATE_COMMENT_LOADING });

    get('graphql').mutate(UPDATE_COMMENT, { comment }, ({ data }) => {
      const { comment } = data.UpdateMe;

      dispatch({ type: UPDATE_COMMENT_SUCCESS, payload: { comment } });
    }, (status) => dispatch({ type: UPDATE_COMMENT_FAILURE, payload: { status } }));
  };
}

/**
 * @param {File} avatar
 */
export function updateAvatar(avatar) {
  return (dispatch) => {
    dispatch({ type: UPDATE_AVATAR_LOADING });

    get('graphql').mutate(UPDATE_AVATAR, { avatar }, ({ data }) => {
      const { avatar } = data.UpdateMe;

      dispatch({ type: UPDATE_AVATAR_SUCCESS, payload: { avatar } });
    }, (status) => dispatch({ type: UPDATE_AVATAR_FAILURE, payload: { status } }));
  };
}



// WEBPACK FOOTER //
// ./src/modules/profile/actions/profile.js